import * as React from 'react';
import { pathwayStore } from '../../store';
import { useZustand } from 'use-zustand';
import classNames from 'classnames';
import { Button } from './../Buttons';
import Modal from './../Modal';
import { Config } from '../../helper';
import Footer, { Preloader as FooterPreloader } from '../Footer';

export default function Summary(props) {
  const {step} = props;
  const [isModalOpen, setModalOpen] = React.useState(false);
  const {
    config = {},
  } = step;
  const {
    cta = '',
    warningMessage = Config.I18n.Summary.DefaultWarningMessage
  } = config;

  const {
    updateStep,
    pathwayID,
    completedStepIDs,
    isAllMainStepsCompleted,
  } = useZustand(pathwayStore, (state) => ({
    pathwayID: state.pathwayID,
    updateStep: state.updateStep,
    completedStepIDs: state.completedStepIDs,
    isAllMainStepsCompleted: state.isAllMainStepsCompleted,
  }));
  const isDisabled = isAllMainStepsCompleted() === false;
  const isSummaryCompleted  = isAllMainStepsCompleted() && (completedStepIDs() && completedStepIDs().includes(step.id));
  const openModal = () => setModalOpen(true);
  const css = {
    root: classNames({
      'pathway-step__details': true,
      'pathway-step__details--not-completed': isDisabled,
    })
  };

  const closeModal = (evt) => {
    setModalOpen(false);
    updateStep(pathwayID, step, Config.Step.Status.completed);
    evt.preventDefault();
  };

  return (
    <div className={css.root}>
      <div className='pathway-step__content'>
        {isDisabled ? (
          <p className='p--large'>{warningMessage}</p>
        ) : (
          <>
            <div dangerouslySetInnerHTML={{__html: step.content}}></div>
            <Modal isOpen={isModalOpen} closeModal={closeModal}/>
          </>
        )}
      </div>
      <div className='pathway-step__actions'>
        {isDisabled ? (
          <Button text={cta} disabled={isDisabled} clickHandler={openModal}/>
        ):(
          <Button text={isSummaryCompleted ? Config.I18n.Summary.Completed : cta} disabled={isDisabled} clickHandler={openModal}/>
        )}
      </div>

      {isDisabled ? <FooterPreloader/> : <Footer content={step.footer}/>}
    </div>
  );
}
